import LogService from "../../CommonSdk/LogService";

import * as InvoicesService from "../../RainbowSdk/InvoicesService";
import * as InvoicesActionTypes from "./InvoicesActionTypes";
import * as CountriesUtils from "../../Utils/CountriesUtils";

const LOG_TAG = "ACTIONS:INVOICES";

export const createInvoiceAccount = (user, methodId) => dispatch => {
    LogService.trace(LOG_TAG, "createInvoiceAccount", "Create an invoice account");

    let data = {
        paymentMethodId: methodId,
    }

    if (CountriesUtils.isUsaCountry(user.country)) {
        data.state = user.state || "AL";
    }

    if (CountriesUtils.isCanadianCountry(user.country)) {
        data.state = user.state || "AB";
    }

    return InvoicesService.createInvoiceAccount(user.id, data)
        .then(json => {
            LogService.trace(LOG_TAG, "createInvoiceAccount success");
            dispatch({
                type: InvoicesActionTypes.CREATE_INVOICES_ACCOUNT_DONE,
                payload: {
                    account: json.data
                }
            });
            return Promise.resolve();
        })
        .catch(errorPayload => {
            LogService.warn(LOG_TAG, "createInvoiceAccount", "error", errorPayload);
            //TrackingService.trackOtherError(error, "Can't get Zuora user account");
            return Promise.reject(errorPayload);
        })
}

export const getInvoiceAccount = (userId) => dispatch => {
    LogService.trace(LOG_TAG, "getInvoiceAccount", "Get an Invoice account");

    dispatch({
        type: InvoicesActionTypes.GET_INVOICES_ACCOUNT_PROGRESS
    });

    return InvoicesService.getInvoiceAccount(userId)
        .then(json => {
            LogService.trace(LOG_TAG, "getInvoiceAccount success");
            if (!Object.keys(json.data).length) {
                json = null;
            }
            dispatch({
                type: InvoicesActionTypes.GET_INVOICES_ACCOUNT_SUCCESS,
                payload: {
                    account: json
                }
            });
            return Promise.resolve();
        })
        .catch(errorPayload => {
            LogService.warn(LOG_TAG, "getInvoiceAccount", "error", errorPayload);
            //TrackingService.trackOtherError(error, "Can't get Zuora user account");
            dispatch({
                type: InvoicesActionTypes.GET_INVOICES_ACCOUNT_ERROR,
                payload: errorPayload
            });
            return Promise.reject(errorPayload);
        });
};

export const updateInvoiceInformation = (userId, data) => dispatch => {
    LogService.trace(LOG_TAG, "updateInvoiceInformation", "Update account information");

    return InvoicesService.updateInvoiceAccount(userId, data)
        .then((json) => {
            LogService.trace(LOG_TAG, "updateInvoiceInformation", "successfully updated");
            dispatch({
                type: InvoicesActionTypes.UPDATE_INVOICES_INFO_SUCCESS,
                payload: {
                    account: json
                }
            });
            return Promise.resolve();
        })
        .catch(errorPayload => {
            LogService.warn(LOG_TAG, "updateInvoiceInformation", "error", errorPayload);
            return Promise.reject(errorPayload);
        });
};

export const saveInvoiceOptions = (userId, data) => dispatch => {
    LogService.trace(LOG_TAG, "saveInvoiceOptions", "Update invoice option");

    dispatch({
        type: InvoicesActionTypes.UPDATE_INVOICES_OPTIONS_PROGRESS
    });

    return InvoicesService.updateInvoiceAccount(userId, data)
        .then((json) => {
            LogService.trace(LOG_TAG, "saveInvoiceOptions", "successfully updated");
            dispatch({
                type: InvoicesActionTypes.UPDATE_INVOICES_OPTIONS_SUCCESS,
                payload: {
                    account: json
                }
            });
        })
        .catch(errorPayload => {
            LogService.warn(LOG_TAG, "saveInvoiceOptions", "error", errorPayload);
            dispatch({
                type: InvoicesActionTypes.UPDATE_INVOICES_OPTIONS_ERROR,
                payload: errorPayload
            });
        });
};

export const getListOfInvoices = (userId) => dispatch => {
    LogService.trace(LOG_TAG, "getListOfInvoices", "retrieves the list of invoices available");

    dispatch({
        type: InvoicesActionTypes.GET_INVOICES_PROGRESS
    });

    return InvoicesService.getListOfInvoices(userId)
        .then((json) => {
            LogService.trace(LOG_TAG, "getListOfInvoices", "successfully get list of invoices");
            dispatch({
                type: InvoicesActionTypes.GET_INVOICES_DONE,
                payload: {
                    invoices: json.data,
                    total: json.total
                }
            });
        })
        .catch(errorPayload => {
            LogService.warn(LOG_TAG, "getListOfInvoices", "error", errorPayload);
            dispatch({
                type: InvoicesActionTypes.GET_INVOICES_ERROR,
                payload: errorPayload
            });
        });
};

export const downloadInvoice = (userId, fileId, callback, context) => dispatch => {
    LogService.trace(LOG_TAG, "downloadInvoice", "download invoices " + fileId);

    dispatch({
        type: InvoicesActionTypes.DOWNLOAD_INVOICES_PROGRESS
    });

    return InvoicesService.downloadInvoice(userId, fileId)
        .then((blob) => {
            LogService.trace(LOG_TAG, "getListOfInvoices", "successfully download invoices");
            dispatch({
                type: InvoicesActionTypes.DOWNLOAD_INVOICES_DONE,
                payload: {
                    invoice: blob
                }
            });

            if (callback) {
                callback.call(context, blob);
            }
        })
        .catch(errorPayload => {
            LogService.warn(LOG_TAG, "downloadInvoice", "error", errorPayload);
            dispatch({
                type: InvoicesActionTypes.DOWNLOAD_INVOICES_ERROR,
                payload: errorPayload
            });
        });
}

export const clearInvoicesMethods = () => dispatch => {
    LogService.trace(LOG_TAG, "clearInvoicesMethods");
    dispatch({
        type: InvoicesActionTypes.CLEAR_INVOICES_METHODS
    });
};